module.exports = __webpack_public_path__ + "img/franchising_terms_icon1.b8cefae5.svg";